import config from "../../../../config";
import { getlist, post } from "../../../../contexts/apicontexts";

const normalizeId = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

const normalizeString = (value) => String(value ?? "").trim();

export const normalizeTicketsSummaryItem = (item) => ({
  organizationName: normalizeString(item?.organizationName ?? item?.OrganizationName) || "Unknown Organization",
  employeeName: normalizeString(item?.employeeName ?? item?.EmployeeName) || "Unassigned",
  customerName: normalizeString(item?.customerName ?? item?.CustomerName) || "Unknown Customer",
  customerUserName: normalizeString(item?.customerUserName ?? item?.CustomerUserName) || "Unknown User",
  ticketsCount: Number(item?.ticketsCount ?? item?.TicketsCount ?? item?.ticketCount ?? item?.TicketCount ?? 0),
});

export const normalizeTicketsSummaryResponse = (response) => ({
  items: Array.isArray(response?.items ?? response?.Items)
    ? (response?.items ?? response?.Items).map(normalizeTicketsSummaryItem)
    : [],
  totalTickets: Number(response?.totalTickets ?? response?.TotalTickets ?? 0),
});

export const fetchTicketsSummaryGrouped = async (filters) => {
  const payload = {
    organizationId: normalizeId(filters?.organizationId),
    customerId: normalizeId(filters?.customerId),
    customerUserId: normalizeString(filters?.customerUserId) || null,
    employeeUserId: normalizeString(filters?.employeeUserId) || null,
    startDate: filters?.startDate || null,
    endDate: filters?.endDate || null,
    status: normalizeString(filters?.status) || null,
  };

  const response = await post(`${config.baseurl}TicketReport/tickets-summary-grouped`, payload);
  if (response?.status === 200) {
    return normalizeTicketsSummaryResponse(response.data || {});
  }

  throw new Error(response?.message || "Tickets summary report could not be loaded.");
};

export const fetchTicketReportStatusOptions = async () => {
  const response = await getlist(`${config.baseurl}TicketReport/status-options`);
  if (response?.status === 200 && Array.isArray(response.data)) {
    return response.data.map((item) => normalizeString(item)).filter(Boolean);
  }

  throw new Error("Ticket status options could not be loaded.");
};
